import React from 'react'
import SplashSlider from '../../common/SplashSlider';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SplashScreen = ({ onFinish }) => {
  return (
<section className='sign_in p-0'>
    <div className="container">
        <SplashSlider onFinish={onFinish}/>
    </div>
</section>
  )
}

export default SplashScreen;